import React from "react";
import { Button } from "../../shadcn/components/ui/button";
import { FC } from "react";
import { useState, useRef } from "react";
import ArrowInclinedSvg from "../../icons/ArrowInclinedSvg";
import UserIcon from "../../icons/UserIcon";
import HeartSvg from "../../icons/HeartSvg";
import LoginSvg from "../../icons/LoginSvg";
import RoundCheckSvg from "../../icons/RoundCheckSvg";
import CallIcon from "../../icons/CallIcon";
import { AuthModalWrapper } from "../../components/web/Auth/AuthModal";
import Logo from "../../icons/Logo";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetTitle,
  SheetTrigger,
} from "../../shadcn/components/ui/sheet";
import { PropertiesMobile } from "./PropertiesMobile";
import { FiMenu } from "react-icons/fi"; // Import a menu icon from react-icons
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { clearAuth, clearGuestUser } from "store";
import { Badge } from "app-v2";

interface HamburgerMenuProps {
  userLoggedin: any;
  className?: string; // Optional className prop for custom styles
  type?: any;
}

export const HamburgerMenu: FC<HamburgerMenuProps> = ({
  className = "",
  userLoggedin,
  type = false,
}) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const [authModelOpen, setAuthModelOpen] = useState(false);
  const sheetCloseRef = useRef<HTMLButtonElement>(null);

  const handleLogin = () => {
    sheetCloseRef.current?.click(); // Close the sheet
    setAuthModelOpen(true); // Open the login modal
  };

  const handlePostYourPropertyClick = () => {
    if (!type) {
      if (userLoggedin) window.open(`/post-your-property`, "_blank");
      else setAuthModelOpen(true);
    } else {
      window.open(
        `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/post-your-property`,
        "_blank"
      );
    }
  };

  const handleLogout = async () => {
    await fetch("/api/logout", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    dispatch(clearAuth());
    dispatch(clearGuestUser());
    router.push("/");
  };

  return (
    <div className={`${className}`}>
      <Sheet>
        <SheetTrigger asChild>
          <Button variant="ghost" size="full_size" className="">
            <FiMenu size={24} />
          </Button>
        </SheetTrigger>
        <SheetContent className="w-full my-auto px-4">
          <SheetTitle className="hidden"></SheetTitle>
          <SheetDescription className="hidden"></SheetDescription>
          <div className="h-full overflow-y-scroll scrollbar-hide">
            <div
              className="py-[13px] cursor-pointer"
              onClick={() => router.push("/")}
            >
              <Logo height="28px" width="98px"></Logo>
            </div>
            {/* Properties Accordian */}
            <div className="mt-6">
              <p className="font-openSans font-semibold text-mobile-body-sm leading-4 text-[#D9D9D9]">
                PROPERTIES
              </p>
              <PropertiesMobile />
            </div>

            {/* Bidding Portal */}
            <div className="mt-[30px]">
              <p className="font-openSans font-semibold text-mobile-body-sm leading-4 text-[#D9D9D9]">
                MY PORTAL
              </p>
              {/* <div
                onClick={() => {
                  if (window != undefined) {
                    window.location.href =
                      process.env.NEXT_PUBLIC_BIDDER_URL || "";
                  }
                }}
                className="hover:cursor-pointer font-openSans font-normal text-mobile-subheading leading-4 text-brand-textBlack pt-5"
              >
                Bidding
              </div> */}
              <div
                onClick={
                  process.env.NEXT_PUBLIC_PYP_ENABLE === "true"
                    ? handlePostYourPropertyClick
                    : () => {}
                }
                className="h-9 py-custom-9 font-openSans text-mobile-subheading leading-4 border-none mt-3 font-semibold"
              >
                Post Property
                <Badge
                  variant={"default"}
                  className="bg-[#ACE459]  font-openSans rounded-sm font-normal text-brand-textBlack px-0 py-0.5 border-none ml-2"
                >
                  <p className="font-openSans text-wrap font-normal text-[8px] leading-[8px] text-brand-textBlack mx-[10px]">
                    Free
                  </p>
                </Badge>
              </div>
            </div>

            {/* Account  */}
            <div
              className="mt-[30px] w-full"
              style={{
                pointerEvents: type ? "none" : "auto",
                opacity: type ? 0.5 : 1,
              }}
            >
              <p className="font-openSans font-semibold text-mobile-body-sm leading-4 text-[#D9D9D9]">
                MY ACCOUNT
              </p>
              <div className="flex h-[6.5rem] justify-around bg-[#FEECE6] w-full mt-2  ">
                {userLoggedin && (
                  <>
                    <a
                      className=" bg-[#FEECE6] my-auto mx-auto space-y-4"
                      href="/dashboard/profile"
                    >
                      <div className="items-center justify-center space-x-2 flex">
                        <UserIcon
                          height="20px"
                          width="20px"
                          bg_color="#FFFFFF"
                        ></UserIcon>
                      </div>
                      <p className="items-center justify-center space-x-2 flex font-openSans font-normal text-mobile-body-md leading-4 text-brand-bgBlack">
                        Profile
                      </p>
                    </a>
                    <div className="border-l-[1px] border-gray-300"></div>
                    <a
                      className=" bg-[#FEECE6] my-auto mx-auto space-y-4"
                      href="/dashboard/shortlisted"
                    >
                      <div className="items-center justify-center space-x-2 flex">
                        <HeartSvg
                          bg_color="#FFFFFF"
                          height="20px"
                          width="20px"
                        ></HeartSvg>
                      </div>
                      <p className="items-center justify-center space-x-2 flex font-openSans font-normal text-mobile-body-md leading-4 text-brand-bgBlack">
                        Shortlisted
                      </p>
                    </a>
                    <div className="border-l-[1px] border-gray-300"></div>
                  </>
                )}

                {userLoggedin ? (
                  <div
                    onClick={handleLogout}
                    className=" bg-[#FEECE6] my-auto mx-auto space-y-4"
                  >
                    <div className="items-center justify-center space-x-2 flex">
                      <LoginSvg
                        height="20px"
                        width="20px"
                        bg_color="#FFFFFF"
                      ></LoginSvg>
                    </div>

                    <p className="items-center justify-center space-x-2 flex font-openSans font-normal text-mobile-body-md leading-4 text-brand-bgBlack">
                      Logout
                    </p>
                  </div>
                ) : (
                  <div
                    onClick={handleLogin}
                    className=" bg-[#FEECE6] my-auto mx-auto space-y-4"
                  >
                    <div className="items-center justify-center space-x-2 flex">
                      <LoginSvg
                        height="20px"
                        width="20px"
                        bg_color="#FFFFFF"
                      ></LoginSvg>
                    </div>

                    <p className="items-center justify-center space-x-2 flex font-openSans font-normal text-mobile-body-md leading-4 text-brand-bgBlack">
                      Login/Register
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* ContactUs */}
            <div
              className="w-full my-10 bg-[#F8F8F8] pl-8 pt-5 h-[241px] bg-wave-pattern1 bg-no-repeat "
              style={{
                clipPath:
                  "polygon(0% 0%, 100% 0%, 100% 80%, 80% 100%, 0% 100%)",
                backgroundPosition: "calc(100% - 4px) -3px", // Set custom position here
              }}
            >
              {/* Call Icon */}
              <div className="">
                <CallIcon height="25" width="25" />
              </div>

              {/* Heading */}
              <h1 className="font-spaceGrotesk font-bold text-web-subheading text-brand-textGrey mt-[13px] w-[140px] h-[19px]">
                Contact Us
              </h1>

              {/* List */}
              <ul className="space-y-[13px] mt-[19px]">
                <li className="flex items-center">
                  <RoundCheckSvg />
                  <p className="pl-2 font-openSans font-normal text-web-body-sm leading-4 text-brand-textGrey">
                    24/7 Support
                  </p>
                </li>
                <li className="flex items-center">
                  <RoundCheckSvg />
                  <p className="pl-2 font-openSans font-normal text-web-body-sm leading-4 text-brand-textGrey">
                    Expert Assistance
                  </p>
                </li>
                <li className="flex items-center">
                  <RoundCheckSvg />
                  <p className="pl-2 font-openSans font-normal text-web-body-sm leading-4 text-brand-textGrey">
                    Finance Assistance
                  </p>
                </li>
              </ul>

              {/* Talk to expert */}
              <a href="/contactus" className="flex mt-[37px]">
                <p className="font-openSans font-semibold text-web-body-sm text-brand-orange">
                  Talk to our Expert
                </p>
                <div className="h-[14px] w-[14px] mt-[2px]">
                  <ArrowInclinedSvg></ArrowInclinedSvg>
                </div>
              </a>
            </div>
          </div>
        </SheetContent>
        <SheetClose ref={sheetCloseRef} />
      </Sheet>
      <AuthModalWrapper
        userLoggedin={userLoggedin}
        authModelOpen={authModelOpen}
        setAuthModelOpen={setAuthModelOpen}
      />
    </div>
  );
};
